module.exports = __webpack_public_path__ + "img/palm0_4.fd035d76.png";